"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var Weights = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Weights, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Weights);

  function Weights() {
    (0, _classCallCheck2["default"])(this, Weights);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Weights, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M3.36363636,8.57142857 L4.27272727,8.57142857 C4.52272727,8.57142857 4.72727273,8.76428571 4.72727273,9 L4.72727273,15 C4.72727273,15.2365714 4.52272727,15.4285714 4.27272727,15.4285714 L3.36363636,15.4285714 C2.61181818,15.4285714 2,14.8517143 2,14.1428571 L2,9.85714286 C2,9.14828571 2.61181818,8.57142857 3.36363636,8.57142857 Z M17,6 C17.7509091,6 18.3636364,6.57685714 18.3636364,7.28571429 L18.3636364,16.7142857 C18.3636364,17.4231429 17.7509091,18 17,18 L15.1818182,18 C14.43,18 13.8181818,17.4231429 13.8181818,16.7142857 L13.8181818,12.8571429 L10.1818182,12.8571429 L10.1818182,16.7142857 C10.1818182,17.4231429 9.56909091,18 8.81818182,18 L7,18 C6.24818182,18 5.63636364,17.4231429 5.63636364,16.7142857 L5.63636364,7.28571429 C5.63636364,6.57685714 6.24818182,6 7,6 L8.81818182,6 C9.56909091,6 10.1818182,6.57685714 10.1818182,7.28571429 L10.1818182,12 L13.8181818,12 L13.8181818,7.28571429 C13.8181818,6.57685714 14.43,6 15.1818182,6 L17,6 Z M22,9.85714286 L22,12.4285714 L22,14.1428571 C22,14.8517143 21.3872727,15.4285714 20.6363636,15.4285714 L19.7272727,15.4285714 C19.4763636,15.4285714 19.2727273,15.2365714 19.2727273,15 L19.2727273,9 C19.2727273,8.76428571 19.4763636,8.57142857 19.7272727,8.57142857 L20.6363636,8.57142857 C21.3872727,8.57142857 22,9.14828571 22,9.85714286 Z"
      }));
    }
  }]);
  return Weights;
}(_react["default"].PureComponent);

var _default = Weights;
exports["default"] = _default;